import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  // Navigation links for the footer
  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'How It Works', path: '/how-it-works' },
    { name: 'Contact', path: '/contact' },
  ];

  // Legal links
  const legalLinks = [
    { name: 'Privacy Policy', path: '/privacy-policy' },
    { name: 'Terms of Service', path: '/terms-of-service' },
    { name: 'Disclaimer', path: '/disclaimer' },
  ];

  return (
    <footer className="bg-dark/90 border-t border-light/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company info and description */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-light font-bold text-xl">Eluno <span className="text-accent">Consulting</span></span>
            </Link>
            <p className="text-[#A0A0A0] text-sm mb-6">
              Strategic consulting services bringing over 25 years of experience to help transform your business with innovative technology solutions.
            </p>
            {/* Social media links */}
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/in/bwilde" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-light hover:text-accent transition-colors duration-300"
                aria-label="Visit LinkedIn Profile"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-light font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path} 
                    className="text-[#A0A0A0] hover:text-accent text-sm transition-colors duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal links */}
          <div>
            <h3 className="text-light font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 mb-6">
              {legalLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path} 
                    className="text-[#A0A0A0] hover:text-accent text-sm transition-colors duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Copyright section */}
        <div className="border-t border-light/10 mt-8 pt-8 text-center">
          <p className="text-[#A0A0A0] text-sm">
            &copy;2025 Eluno Consulting. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;